// @core/api/endpoints/platform/delete_platform.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/platform';

/**
 * Delete platform
 * Permanently deletes a platform and all associated data. This action is irreversible and requires owner privileges.
 */
export async function DeletePlatform(
  platform_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/platforms/:platform_id`;
  requestPath = requestPath.replace(':platform_id', encodeURIComponent(platform_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
